import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DemandeType } from '@models/enums';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private http: HttpClient) {}

  getDemandePdf(id: any, type: DemandeType): Observable<Blob> {
    const url = `/demandes/${id}/generated-pdf/${type}`;
    return this.http.get(this.module + url, { responseType: 'blob' });
  }

  getDemandesPdf(id: any, type: any): Observable<any> {
    const body = {
      Recrutement: [id]
    };
    return this.http.get(`${this.module}/demandes/with-generated-pdf`, { params: body });
  }
}
